<template>
  <div class="dropdown dropdown-end">
    <div tabindex="0" role="button" class="btn btn-ghost btn-sm sm:btn-md rounded-lg">
      <svg v-if="currentTheme === 'dark'" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    </div>
    <ul tabindex="0" class="dropdown-content z-[1] max-h-80 overflow-y-auto menu p-2 shadow bg-base-100 rounded-box w-56 sm:w-64 mt-2">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-1">
        <li v-for="theme in themes" :key="theme">
          <a @click="setTheme(theme)" :class="{ 'active': currentTheme === theme }" class="py-2 px-3 text-sm">
            {{ formatThemeName(theme) }}
          </a>
        </li>
      </div>
    </ul>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';

const themes = ["light", "dark", "bumblebee", "corporate", "night", "cupcake", "emerald", "synthwave", "retro", "cyberpunk", "valentine", "halloween", "garden", "forest", "aqua", "lofi", "pastel", "fantasy", "wireframe", "luxury", "dracula", "cmyk", "autumn", "business", "acid", "lemonade", "winter"];
const currentTheme = ref('');

function formatThemeName(theme) {
  return theme.charAt(0).toUpperCase() + theme.slice(1);
}

function setTheme(theme) {
  currentTheme.value = theme;
  localStorage.setItem('theme', theme);
  document.documentElement.setAttribute('data-theme', theme);
  
  // Toggle dark class for Tailwind
  if (theme === 'dark' || theme === 'night') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

onMounted(() => {
  // Get theme from localStorage or use default
  const savedTheme = localStorage.getItem('theme') || 'light';
  setTheme(savedTheme);
});
</script> 